import { initializeApp } from "firebase/app"
import {
  browserLocalPersistence,
  getAuth,
  setPersistence,
  connectAuthEmulator,
} from "firebase/auth"
import { getFirestore, connectFirestoreEmulator, collection } from "firebase/firestore"
import { getFunctions, connectFunctionsEmulator } from "firebase/functions"
import { getStorage, connectStorageEmulator } from "firebase/storage"
import { getMessaging, getToken, isSupported } from "firebase/messaging"
import { getAnalytics } from "firebase/analytics"
import Config from "../config"

const firebaseConfig = {
  apiKey: Config.firebaseApiKey,
  authDomain: Config.firebaseAuthDomain,
  databaseURL: Config.firebaseDatabaseUrl,
  projectId: Config.firebaseProjectId,
  storageBucket: Config.firebaseStorageBucket,
  messagingSenderId: Config.firebaseMessagingSenderId,
  appId: Config.firebaseAppId,
  measurementId: Config.firebaseMeasurementId,
}

export const getFirebaseAnalytics = () => {
  try {
    if (!navigator.onLine) {
      console.warn("[Firebase] Analytics initialization skipped: browser is offline")
      return null
    }
    return getAnalytics(app)
  } catch (error) {
    console.error("[Firebase] Failed to initialize analytics:", error)
    return null
  }
}

const app = initializeApp(firebaseConfig)

export const functions = getFunctions(app)
export const auth = getAuth(app)
export const analytics = getFirebaseAnalytics()
export const fcmService = (async () => {
  try {
    const isSupportedBrowser = await isSupported()
    if (isSupportedBrowser) return getMessaging(app)
    console.log("Firebase not supported this browser")
    return null
  } catch (err) {
    console.log(err)
    return null
  }
})()

// Progressive Enhancement (SW supported)
if (navigator.serviceWorker) {
  const UrlFirebaseConfig = new URLSearchParams(firebaseConfig)

  const swUrl = `/firebase-messaging-sw.js?${UrlFirebaseConfig.toString()}`

  // Register the SW
  navigator.serviceWorker
    .register(swUrl)
    .then((serviceWorkerRegistration) => {
      // we should always get the token on app load for auth purposes to prevent token regeneration issues
      fcmService
        .then((fcmInstance) => {
          if (!fcmInstance) return
          return getToken(fcmInstance, {
            vapidKey: Config.firebaseVapidKey,
            serviceWorkerRegistration,
          }).catch((err) => console.error("fcm token failure", err))
        })
        .catch((err) => console.error("messaging failure", err))
    })
    .catch((err) => console.error("service worker registration failure", err))
}

export const firestore = getFirestore(app)
export const tripsCollection = collection(firestore, "Trips")
export const avatarStorage = getStorage(app, Config.avatarBucketName)
export const filesStorage = getStorage(app, Config.filesBucketName)

setPersistence(auth, browserLocalPersistence)

if (Config.useEmulators) {
  connectAuthEmulator(auth, `http://${Config.emulatorHost}:9099`)
  connectFunctionsEmulator(functions, Config.emulatorHost, 5001)
  connectFirestoreEmulator(firestore, Config.emulatorHost, 8080)
  connectStorageEmulator(avatarStorage, Config.emulatorHost, 9199)
  connectStorageEmulator(filesStorage, Config.emulatorHost, 9199)
}
